module.exports = __webpack_public_path__ + "img/homebannerbg4.8b8bdc7d.png";